









import Vue from 'vue'
import SmallRowOfferEl from '@/components/elements/SmallRowOfferEl.vue'
import { SmallAddOnElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'SmallAddOnEl',

  components: { SmallRowOfferEl },

  props: {
    templateItemData: {
      type: Object as () => SmallAddOnElInterface,
      required: true
    }
  }
})
